import { all, put } from 'redux-saga/effects';
import { AxiosError } from 'axios';

import mapAPIError from '../../mapAPIError';
import mapMultipleAPIError from '../../mapMultipleAPIErrors';

import { createToast } from '../actions/toasts.actions';

import { APIError } from '../../types';
import { CreateToastPayload } from '../actions/toasts.types';

type ExtraData = {
  saga?: string;
  method?: string;
  url?: string;
  payload?: any;
  apiRoot?: string | null;
  env?: string | null;
  apiResponseTime?: number;
} | null;

export function* handleApiErrors(errors: APIError[], data: any = null, apiResponseTime?: number) {
  const apiRoot = data?.config?.APIGEE_BASE_URL ?? null;
  const env = data ? data?.config?.ENV : null;

  // FIXED: Added explicit type annotation
  let extraData: ExtraData = null;
  if (data) {
    extraData = {
      saga: data?.saga,
      method: data?.method,
      url: data?.url,
      payload: data?.data,
      apiRoot,
      env,
      apiResponseTime,
    };
  } else if (apiResponseTime !== undefined) {
    extraData = { apiResponseTime };
  }

  if (errors?.length > 0) {
    const errorSet = new Set();
    errors.forEach(error => errorSet.add(error.code));
    let filteredErrors: APIError[] = errors;

    if (errorSet.has('COMMERCIAL_ORDER_SERVICE_DOWN') && errorSet.has('REPLENISHMENT_ORDER_SERVICE_DOWN')) {
      filteredErrors = errors.filter(
        err => err.code === 'COMMERCIAL_ORDER_SERVICE_DOWN' || err.code === 'REPLENISHMENT_ORDER_SERVICE_DOWN'
      );
      yield put(createToast({ type: 'error', message: mapMultipleAPIError(filteredErrors) }));
      filteredErrors = errors.filter(
        err => !(err.code === 'COMMERCIAL_ORDER_SERVICE_DOWN' || err.code === 'REPLENISHMENT_ORDER_SERVICE_DOWN')
      );
    }

    yield all([
      ...filteredErrors.map(error =>
        put(
          createToast(
            extraData
              ? { type: 'error', message: mapAPIError(error), error, extraData }
              : { type: 'error', message: mapAPIError(error), error }
          )
        )
      ),
    ]);
  }
}

export function* catchApiErrors(error: AxiosError, data: any = null, apiResponseTime?: number) {
  const errors = error && error.response && error.response.data.errors;
  const apiRoot = data?.config?.APIGEE_BASE_URL ?? null;
  const env = data ? data?.config?.ENV : null;

  // FIXED: Always include apiResponseTime even when data is null
  let extraData: ExtraData = null;
  if (data) {
    extraData = {
      saga: data?.saga,
      method: data?.method,
      url: data?.url,
      payload: data?.data,
      apiRoot,
      env,
      apiResponseTime,
    };
  } else if (apiResponseTime !== undefined) {
    extraData = { apiResponseTime }; // ← This ensures apiResponseTime is preserved
  }

  const toast: CreateToastPayload = {
    type: 'error',
    message: 'An error has occurred...',
    error,
  };

  if (extraData) toast.extraData = extraData;

  if (errors) {
    yield handleApiErrors(errors, data, apiResponseTime);
  } else {
    yield put(createToast(toast));
  }
}
